(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const syncFooters = (root = document) => {
      const mode = window.innerWidth > 768 ? 'desktop' : 'mobile';

      root.querySelectorAll('.custom-footer [data-footer-toggle]').forEach((toggle) => {
        if (toggle.dataset.footerMode === mode) return;

        const column = toggle.closest('.footer-column');
        column.classList.remove('active');
        toggle.setAttribute('aria-expanded', mode === 'desktop' ? 'true' : 'false');
        toggle.dataset.footerMode = mode;
      });
    };

    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('.custom-footer [data-footer-toggle]');
      if (!toggle || window.innerWidth > 768) return;

      const column = toggle.closest('.footer-column');
      const expanded = column.classList.toggle('active');
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });

    document.addEventListener('DOMContentLoaded', () => syncFooters());
    document.addEventListener('shopify:section:load', (event) => syncFooters(event.target));
    window.addEventListener('resize', () => syncFooters());
    syncFooters();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lotus-article-reader"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const copyArticleUrl = async (reader) => {
      const url = reader.dataset.shareUrl;
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(url);
        } else {
          const textarea = document.createElement('textarea');
          textarea.value = url;
          textarea.style.position = 'fixed';
          textarea.style.opacity = '0';
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand('copy');
          textarea.remove();
        }

        const status = reader.querySelector('[data-article-share-status]');
        if (status) {
          status.textContent = reader.dataset.copiedText;
          window.setTimeout(() => {
            status.textContent = '';
          }, 2400);
        }
      } catch (error) {
        window.prompt('', url);
      }
    };

    const initArticleReader = (reader) => {
      if (reader.dataset.articleReady === 'true') return;
      reader.dataset.articleReady = 'true';

      const content = reader.querySelector('[data-article-content]');

      const shareButton = reader.querySelector('[data-article-share]');
      if (shareButton) {
        shareButton.addEventListener('click', async () => {
          if (navigator.share) {
            try {
              await navigator.share({
                title: reader.dataset.shareTitle,
                url: reader.dataset.shareUrl
              });
              return;
            } catch (error) {
              if (error.name === 'AbortError') return;
            }
          }
          await copyArticleUrl(reader);
        });
      }

      const backLink = reader.querySelector('[data-article-back]');
      if (backLink) {
        backLink.addEventListener('click', (event) => {
          let referrer;
          try {
            referrer = document.referrer ? new URL(document.referrer) : null;
          } catch (error) {
            referrer = null;
          }

          const canReturn = referrer
            && referrer.origin === window.location.origin
            && referrer.pathname !== window.location.pathname
            && window.history.length > 1;

          if (canReturn) {
            event.preventDefault();
            window.history.back();
          }
        });
      }

      const progress = reader.querySelector('[data-article-progress]');
      if (content && progress) {
        const updateProgress = () => {
          const contentTop = content.getBoundingClientRect().top + window.scrollY;
          const distance = Math.max(content.offsetHeight - window.innerHeight, 1);
          const value = Math.min(Math.max((window.scrollY - contentTop) / distance, 0), 1);
          progress.style.transform = `scaleX(${value})`;
        };
        updateProgress();
        window.addEventListener('scroll', updateProgress, { passive: true });
        window.addEventListener('resize', updateProgress);
      }
    };

    const initAllArticleReaders = (root = document) => {
      root.querySelectorAll('[data-lotus-article-reader]').forEach(initArticleReader);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAllArticleReaders());
    } else {
      initAllArticleReaders();
    }

    document.addEventListener('shopify:section:load', (event) => initAllArticleReaders(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lotus-offer-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializePopup = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const dialog = root.querySelector('[data-lop-dialog]');
      if (!dialog) return;

      const closeButtons = root.querySelectorAll('[data-lop-close]');
      const copyButton = root.querySelector('[data-lop-copy]');
      const copyStatus = root.querySelector('[data-lop-copy-status]');
      const emailInput = root.querySelector('input[type="email"]');
      const hasFormResult = Boolean(root.querySelector('[data-lop-result]'));
      const designMode = root.dataset.designMode === 'true';
      const enabled = root.dataset.enabled === 'true';
      const closeOnBackdrop = root.dataset.closeOnBackdrop === 'true';
      const repeatHours = Number(root.dataset.repeatHours || 24);
      const delayMilliseconds = Number(root.dataset.delaySeconds || 0) * 1000;
      const campaignKey = root.dataset.campaignKey || 'welcome-offer';
      const storageKey = `lotus_offer_popup_${campaignKey}`;
      let previouslyFocused = null;
      let closeTimer = null;

      const readLastShown = () => {
        try {
          return Number(window.localStorage.getItem(storageKey) || 0);
        } catch (error) {
          return 0;
        }
      };

      const writeLastShown = () => {
        try {
          window.localStorage.setItem(storageKey, String(Date.now()));
        } catch (error) {
          return;
        }
      };

      const openPopup = (ignoreFrequency = false) => {
        if (dialog.open) return;
        if (!enabled && !designMode) return;

        if (!ignoreFrequency && !hasFormResult) {
          const elapsed = Date.now() - readLastShown();
          if (elapsed < repeatHours * 60 * 60 * 1000) return;
        }

        previouslyFocused = document.activeElement;
        dialog.showModal();
        document.documentElement.classList.add('lotus-offer-popup-open');

        if (!hasFormResult && !designMode) {
          writeLastShown();
        }

        window.setTimeout(() => {
          if (hasFormResult) {
            const resultFocusTarget = copyButton || dialog.querySelector('[data-lop-close]');
            resultFocusTarget?.focus({ preventScroll: true });
          } else {
            emailInput?.focus({ preventScroll: true });
          }
        }, 260);
      };

      const closePopup = () => {
        if (!dialog.open || dialog.classList.contains('is-closing')) return;
        dialog.classList.add('is-closing');
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => {
          dialog.close();
          dialog.classList.remove('is-closing');
          document.documentElement.classList.remove('lotus-offer-popup-open');
          previouslyFocused?.focus?.({ preventScroll: true });
        }, 260);
      };

      closeButtons.forEach((button) => {
        button.addEventListener('click', closePopup);
      });

      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        closePopup();
      });

      dialog.addEventListener('click', (event) => {
        if (closeOnBackdrop && event.target === dialog) {
          closePopup();
        }
      });

      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('lotus-offer-popup-open');
      });

      const copyText = async (text) => {
        if (navigator.clipboard?.writeText && window.isSecureContext) {
          try {
            await navigator.clipboard.writeText(text);
            return true;
          } catch (error) {
          }
        }

        const temporaryField = document.createElement('textarea');
        temporaryField.value = text;
        temporaryField.setAttribute('readonly', '');
        temporaryField.setAttribute('aria-hidden', 'true');
        temporaryField.style.position = 'fixed';
        temporaryField.style.top = '0';
        temporaryField.style.left = '0';
        temporaryField.style.width = '1px';
        temporaryField.style.height = '1px';
        temporaryField.style.padding = '0';
        temporaryField.style.border = '0';
        temporaryField.style.opacity = '0';
        temporaryField.style.pointerEvents = 'none';
        temporaryField.style.fontSize = '16px';
        dialog.appendChild(temporaryField);
        temporaryField.focus({ preventScroll: true });
        temporaryField.select();
        temporaryField.setSelectionRange(0, text.length);

        let copied = false;
        try {
          copied = document.execCommand('copy');
        } catch (error) {
          copied = false;
        }

        temporaryField.remove();
        copyButton?.focus({ preventScroll: true });
        return copied;
      };

      copyButton?.addEventListener('click', async () => {
        const codeValue = copyButton.querySelector('.lotus-offer-popup__code-value');
        const code = codeValue?.textContent?.trim() || copyButton.dataset.code?.trim() || '';
        if (!code) return;

        const copied = await copyText(code);
        const copiedLabel = copyStatus?.dataset.copiedLabel || 'Copied';
        const failedLabel = copyStatus?.dataset.copyFailedLabel || 'Copy failed';
        const feedbackLabel = copied ? copiedLabel : failedLabel;
        if (copyStatus) copyStatus.textContent = feedbackLabel;
        const visualLabel = copyButton.querySelector('[data-lop-copy-label]');
        if (visualLabel) {
          const originalLabel = visualLabel.textContent;
          visualLabel.textContent = feedbackLabel;
          window.setTimeout(() => {
            visualLabel.textContent = originalLabel;
          }, 1800);
        }
      });

      if (hasFormResult) {
        window.setTimeout(() => openPopup(true), 120);
      } else if (!designMode && enabled) {
        window.setTimeout(() => openPopup(false), delayMilliseconds);
      }

      if (designMode) {
        document.addEventListener('shopify:section:select', (event) => {
          if (event.detail.sectionId === root.dataset.sectionId) {
            openPopup(true);
          }
        });

        document.addEventListener('shopify:section:deselect', (event) => {
          if (event.detail.sectionId === root.dataset.sectionId) {
            closePopup();
          }
        });
      }
    };

    const initializeAllPopups = (container = document) => {
      container.querySelectorAll('[data-lotus-offer-popup]').forEach(initializePopup);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAllPopups());
    } else {
      initializeAllPopups();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeAllPopups(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lotus-product-information"]) return;
  try {
    
  if (!customElements.get('lotus-product-detail')) {
    customElements.define(
      'lotus-product-detail',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', this.handleClick)
          this.querySelectorAll('[data-lpd-dialog]').forEach((dialog) => {
            dialog.addEventListener('click', this.handleBackdrop)
            dialog.addEventListener('close', this.handleDialogClose)
          })
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.handleClick)
          this.querySelectorAll('[data-lpd-dialog]').forEach((dialog) => {
            dialog.removeEventListener('click', this.handleBackdrop)
            dialog.removeEventListener('close', this.handleDialogClose)
          })
          this.unlockPageScroll()
        }

        handleClick = (event) => {
          const opener = event.target.closest('[data-lpd-open]')
          if (opener) {
            const dialog = this.querySelector(`#${CSS.escape(opener.dataset.lpdOpen)}`)
            if (dialog && !dialog.open) {
              dialog.showModal()
              this.lockPageScroll()
            }
            return
          }

          const closer = event.target.closest('[data-lpd-close]')
          if (closer) closer.closest('dialog')?.close()
        }

        handleBackdrop = (event) => {
          if (event.target === event.currentTarget) event.currentTarget.close()
        }

        handleDialogClose = (event) => {
          event.currentTarget.querySelectorAll('video').forEach((video) => video.pause())
          this.unlockPageScroll()
        }

        lockPageScroll = () => {
          if (document.documentElement.classList.contains('lpd-dialog-open')) return

          this.lockedScrollY = window.scrollY
          this.previousBodyTop = document.body.style.top
          document.body.style.top = `-${this.lockedScrollY}px`
          document.documentElement.classList.add('lpd-dialog-open')
          document.body.classList.add('lpd-dialog-open')
        }

        unlockPageScroll = () => {
          if (!document.documentElement.classList.contains('lpd-dialog-open')) return

          document.documentElement.classList.remove('lpd-dialog-open')
          document.body.classList.remove('lpd-dialog-open')
          document.body.style.top = this.previousBodyTop || ''
          window.scrollTo(0, this.lockedScrollY || 0)
        }
      }
    )
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-return-link')) {
    customElements.define(
      'product-return-link',
      class extends HTMLElement {
        connectedCallback() {
          this.link = this.querySelector('[data-product-return-link]')
          this.link?.addEventListener('click', this.handleClick)
        }

        disconnectedCallback() {
          this.link?.removeEventListener('click', this.handleClick)
        }

        handleClick = (event) => {
          if (!document.referrer || window.history.length <= 1) return

          try {
            const previousUrl = new URL(document.referrer)
            const currentUrl = new URL(window.location.href)
            const canReturn = previousUrl.origin === currentUrl.origin && previousUrl.href !== currentUrl.href

            if (canReturn) {
              event.preventDefault()
              window.history.back()
            }
          } catch (error) {
            // The link's homepage href remains the safe fallback.
          }
        }
      }
    )
  }

  } catch(e) { console.error(e); }
})();
})();
